module.exports = __webpack_public_path__ + "img/grand-cancun-hotel.04803108.jpg";